import { useRef, useCallback } from 'react';

const SEQUENCE = ['3', '2', '1'];
const WINDOW_MS = 3000;
const MOBILE_BREAKPOINT = 767;

// Returns a `tap(value)` function callers attach to onClick handlers on
// individual rule-number circles. When the trailing taps spell SEQUENCE
// within WINDOW_MS AND the viewport is below MOBILE_BREAKPOINT, calls
// onTrigger. Desktop viewports are intentionally ignored — the keyboard
// "EDC" secret already covers that surface.
export default function useEdcTapSecret(onTrigger, { enabled = true } = {}) {
  const bufferRef = useRef([]);

  return useCallback(
    (value) => {
      if (!enabled) return;
      if (typeof window === 'undefined') return;
      if (window.innerWidth >= MOBILE_BREAKPOINT) return;
      const now = Date.now();
      const buf = bufferRef.current
        .filter((t) => now - t.t <= WINDOW_MS)
        .concat({ v: String(value), t: now });
      while (buf.length > SEQUENCE.length) buf.shift();
      bufferRef.current = buf;
      const trailing = buf.map((t) => t.v).join(',');
      if (trailing === SEQUENCE.join(',')) {
        const span = buf[buf.length - 1].t - buf[0].t;
        if (span <= WINDOW_MS) {
          bufferRef.current = [];
          onTrigger();
        }
      }
    },
    [onTrigger, enabled],
  );
}
